module.exports = __webpack_public_path__ + "static/media/zip.372a9576.svg";